import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React, { useMemo } from "react";
import styled from "styled-components";
import { AttachmentSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { gap } from "@ui/styles/utils";
import {
	useChapterController,
	useEditorController,
} from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

interface AttachmentSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: AttachmentSection;
}
export const AttachmentSectionEditor: React.FC<AttachmentSectionEditorProps> = ({ section, ...htmlProps }) => {
	const chapterController = useChapterController();
	const attachmentController = useMemo(() => chapterController.attachmentSectionController(section), []);
	const courseController = useEditorController();
	const observableCourse = useObservable(courseController.course);
	const asset = getAssetById(observableCourse.content, section.assetId);

	if (!asset) {
		return null;
	}

	return (
		<Container {...htmlProps}>
			<SimpleTextInput
				renderBefore={() => <Extension>{asset.mimeType.split("/")[1]}</Extension>}
				placeholder={I18n.t("course.editor.section.attachment.placeholder")}
				value={section.title}
				onChange={(v) => attachmentController.setTitle(v)}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	${gap(20)};

	.input-wrapper {
		border: none;
		padding-left: 10px;
	}
`;

const Extension = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	border-radius: 12px;
	padding: 5px 10px;
	color: ${({ theme }) => theme.colors.white};
`;
